// ─────────────────────────────────────────────
//  useWatchlist.js
// ─────────────────────────────────────────────
import { useState, useEffect } from "react";
import { db } from "../config/firebaseconfig";
import { collection, onSnapshot, addDoc, deleteDoc, doc, updateDoc } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import { fetchBatchQuotes } from "../config/api";

export function useWatchlist() {
  const { user } = useAuth();
  const [items,    setItems]    = useState([]);
  const [liveData, setLiveData] = useState({});
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    if (!user) return;
    const ref = collection(db, "users", user.uid, "watchlist");
    const unsub = onSnapshot(ref, (snap) => {
      setItems(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return unsub;
  }, [user]);

  useEffect(() => {
    if (!items.length) return;
    async function loadPrices() {
      try {
        const quotes = await fetchBatchQuotes(
          items.map((i) => ({ symbol: i.symbol, exchange: i.exchange || "NSE" }))
        );
        const map = {};
        quotes.forEach((q) => { if (q) map[q.symbol] = q; });
        setLiveData(map);
      } catch (e) { console.error(e); }
    }
    loadPrices();
    const interval = setInterval(loadPrices, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [items]);

  const addToWatchlist = (data) =>
    addDoc(collection(db, "users", user.uid, "watchlist"), { ...data, added_date: new Date() });

  const removeFromWatchlist = (id) =>
    deleteDoc(doc(db, "users", user.uid, "watchlist", id));

  const updateWatchlistItem = (id, data) =>
    updateDoc(doc(db, "users", user.uid, "watchlist", id), data);

  return { items, liveData, loading, addToWatchlist, removeFromWatchlist, updateWatchlistItem };
}